import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { NodeService } from 'src/app/shared/services/node.services';
import { HelpersService } from 'src/app/shared/services/helpers.service';

@Component({
  selector: 'app-subtree-sitemap',
  templateUrl: './subtree-sitemap.component.html',
  styleUrls: ['./subtree-sitemap.component.scss']
})
export class SubtreeSitemapComponent implements OnInit {

  @Input() menu: any = [];

  constructor(
    public nodeService: NodeService,
    public helpersService: HelpersService,
    public navigationService: NavigationService,
    private translate: TranslateService
  ) {
  }

  ngOnInit(): void {
  }

}
